import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const gorgias = defineConnector({
  identifier: "gorgias",
  name: "Gorgias",
  tagLine: "E-commerce helpdesk",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://[^/]*\\.gorgias\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Enter your Gorgias instance details",
      items: [
        {
          kind: "markdown",
          content: "Enter the details for your Gorgias instance.",
        },
        {
          kind: "input",
          label: "Gorgias Domain",
          placeholder: "domain",
          required: true,
          target: { kind: "configuration", field: "subdomain" },
          helperText:
            "The subdomain of your Gorgias account (e.g. https://domain.gorgias.com)",
        },
      ],
    },
    {
      title: "Create a Gorgias app",
      items: [
        {
          kind: "markdown",
          content:
            "In your Gorgias account, go to **Settings → REST API** and create an OAuth application to get your client credentials.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/gorgias/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Configure scopes",
      items: [
        {
          kind: "input",
          label: "Scopes",
          placeholder: "offline",
          helperText: "Space-separated list of permission scopes.",
          target: { kind: "oauthConnection", field: "scopes" },
        },
      ],
    },
    {
      title: "Authorize your Gorgias account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Gorgias account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: (configuration) =>
      `https://${configuration.subdomain}.gorgias.com/oauth/authorize`,
    tokenEndpoint: (configuration) =>
      `https://${configuration.subdomain}.gorgias.com/oauth/token`,
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: (configuration) =>
      `https://${configuration.subdomain}.gorgias.com/api/users`,
  },
  publicEnvVars: ({ subdomain }) => ({
    GORGIAS_URL: subdomain ? `https://${subdomain}.gorgias.com` : "",
  }),
});
